export interface IPrismicComponentBody {
  type: string;
  fields?: [
    {
      component?: string;
      demo_code?: [
        {
          text?: string;
        },
      ];
      demo_summary?: [
        {
          type: string;
          text: string;
        },
      ];
    },
  ];
  primary?: {
    demo_description: [
      {
        type: string;
        text: string;
      },
    ];
    demo_title: [
      {
        text?: string;
      },
    ];
  };
}

const usePrismicComponentBody = (bodyArr: IPrismicComponentBody[], section: string) => {
  if (!bodyArr) {
    return bodyArr;
  }
  const bodySection = bodyArr.filter((body) => {
    if (body.type && body.type.includes(section)) {
      return true;
    }
    return false;
  });

  return bodySection || false;
};

export default usePrismicComponentBody;
